<template>
	<div id="trash-folder-empty-modal" class="modal-new hidden">
		<!-- <svg class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
			<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
			<path d="M0 0h24v24H0z" fill="none" />
		</svg> -->
		<span class="title">Delete Bin</span>
		<p class="description">
			Are you sure you want to Empty the Trash of Bin: <br />"<span>{{ binName }}</span
			>"?
		</p>
		<div class="buttons-continer">
			<button type="button" class="modal-btn --primary --delete" @click="empty">Empty Trash</button>
			<button type="button" class="modal-btn --cancel" @click="onCancel">Cancel</button>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		binName() {
			if (!this.$store.state.Projects.action?.data?.parent_id) return;

			const bin = this.$store.getters['Projects/binById'](this.$store.state.Projects.action?.data?.parent_id);
			if (bin) return bin?.name;
			else return false;
		},
	},
	methods: {
		async empty() {
			await this.$store.dispatch("Projects/emptyTrash");
			this.$store.dispatch("Projects/refreshProjectTree");
			window.UI.hideModal();
		},
		onCancel() {
			window.UI.hideModal();
		},
	},
};
</script>

<style></style>
